const API_CONTRACT_MANAGER_BASE_URL = process.env.VUE_APP_API_CONTRACT_MANAGER_BASE_URL

// Sample build to use in service
// const url = POST.COMMENT.replace('{postId}', 1)
const CONTRACT_MANAGER_URL_FORMAT = {
  AUTH: '/auth',
  CHECK_OTP: '/check-otp',
  COMPANY: '/company',
  USER: '/user',
  AGENT: '/agent',
  CONTRACT: '/contract',
  CHANGE_COMPANY: '/change-company',
  HOTEL: '/hotel',
  SETTING: '/setting',
  EMAIL: '/email',
  SPECIAL_OFFER: '/special-offer'
}

const buildServiceUrl = (baseUrl, serviceList) => {
  let result = {}
  Object.keys(serviceList).map(function (key, index) {
    result[key] = baseUrl + serviceList[key]
  })

  return result
}

export const CONTRACT_MANAGER_URL = buildServiceUrl(API_CONTRACT_MANAGER_BASE_URL, CONTRACT_MANAGER_URL_FORMAT)
